import { select } from 'd3';
import data from '../../data/text.json';

const ids = ['2-1', '2-2', '2-3', '2-4', '4-1'];

ids.forEach(id => {
  const container = select(`#photo_${id}`);
  const dat = data[`photo_${id}`][0];

  // append img
  container
    .append('div')
    .attr('class', 'photo-container')
    .append('img')
    .attr('src', dat.embed_url)
    .attr('loading', 'lazy')
    .attr('alt', `A photo showing ${dat.embed_caption}`)
    .attr('width', '100%');

  // caption
  const caption = container.append('figcaption').attr('class', 'caption');
  caption.append('span').html(`${dat.embed_caption}&nbsp;`);

  // camera icon
  caption
    .append('span')
    .attr('class', 'c-icon')
    .append('svg')
    .attr('area-hidden', true)
    .append('use')
    .attr('xlink:href', '#camera');

  // credit
  caption
    .append('span')
    .attr('class', 'credit')
    .html(`&nbsp;${dat.embed_credit}`);
});
